// this file is automatically generated by the scripts/git-version.js script
export const versions = {
  version: '0.0.0',
  revision: '28b595829bde39a46ded4ad66033106f07209be0',
  branch: 'master',
  date: '1744080524744'
};
